import { render, staticRenderFns } from "./CertificatesInfo.vue?vue&type=template&id=7298d7f5&"
import script from "./CertificatesInfo.vue?vue&type=script&lang=js&"
export * from "./CertificatesInfo.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports